<template>
    <a-modal
        :class="'modal epic-' + moduleStateLink"
        :title="$t('company.deleted_claim_history.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        :footer="null"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '1536px' }"
    >
        <div class="form-container">
            <deleted-log-table :company_id="company_id" />
        </div>
    </a-modal>
</template>

<script>
import DeletedLogTable from '@/components/tables/DeletedLogs.vue';

export default {
    components: {
        DeletedLogTable,
    },
    data() {
        return {
            modal_visible: false,
        };
    },
    props: {
        company_id: {
            type: String,
            default: '',
        },
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
        },
    },
};
</script>
